import { render } from "./Factor.vue?vue&type=template&id=a52557b2"
import script from "./Factor.vue?vue&type=script&lang=js"
export * from "./Factor.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/bime-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__